import { render } from "./first_time_password_reset.html?vue&type=template&id=65727adc&external"
import script from "./first_time_password_reset.js?vue&type=script&lang=js&external"
export * from "./first_time_password_reset.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__